import React, { useEffect, useState } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handleAutoCapitalizeallowNumAlphat, handlePaste } from '../../CommonUtils/CommonValidations';
import Swal from 'sweetalert2';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';
import moment from 'moment';
import * as Yup from 'yup';
import { ERROR_MSG, IFSC_VALIDATION } from '../../CommonUtils/contextVariables';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { FaEye } from 'react-icons/fa';

export default function AffliationIncomeDetails() {
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const AffliationIncomeDetailsValidation = Yup.object({
        stateGovIncome: Yup.string().required(ERROR_MSG).nullable(),
        centralGovIncome: Yup.string().required(ERROR_MSG).nullable(),
        universityGrantsCommission: Yup.string().required(ERROR_MSG).nullable(),
        othersCentralStateGovBodies: Yup.string().required(ERROR_MSG).nullable(),
        privateTrust: Yup.string().required(ERROR_MSG).nullable(),
        donations: Yup.string().required(ERROR_MSG).nullable(),
        studentFee: Yup.string().required(ERROR_MSG).nullable(),
        internalRevenueGenerated: Yup.string().required(ERROR_MSG).nullable(),
        salaryOfFullTimeFaculty: Yup.string().required(ERROR_MSG).nullable(),
        salaryOfVisitingFaculty: Yup.string().required(ERROR_MSG).nullable(),
        salaryForNonTeachingStaff: Yup.string().required(ERROR_MSG).nullable(),
        library: Yup.string().required(ERROR_MSG).nullable(),
        computerCentre: Yup.string().required(ERROR_MSG).nullable(),
        equipmentForLabsWorkshop: Yup.string().required(ERROR_MSG).nullable(),
        othersIncome: Yup.string().required(ERROR_MSG).nullable(),

        nameOfThe: Yup.string().when('othersIncome', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        incomeDetailsOther: Yup.string().when('othersIncome', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        othersExpenditure: Yup.string().required(ERROR_MSG).nullable(),

        nameOfOtherExpenditure: Yup.string().when('othersExpenditure', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        expenditureSalOther: Yup.string().when('othersExpenditure', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        cashBalance: Yup.string().required(ERROR_MSG).nullable(),
        ifscCode: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION, 'Invalid Ifsc Code'),
        fdr: Yup.string().required(ERROR_MSG).nullable(),
        bankName: Yup.string().required(ERROR_MSG),

        bankName3: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        ifscCode3: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION, 'Invalid Ifsc Code'),
            otherwise: Yup.string().nullable(),
        }),
        fdrNumber3: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdBondCerti3: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        fdrNumberValidUpto3: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        bankName4: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        ifscCode4: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION, 'Invalid Ifsc Code'),
            otherwise: Yup.string().nullable(),
        }),
        fdBondCerti4: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdrNumber4: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdrNumberValidUpto4: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        acNo: Yup.string().required(ERROR_MSG).min(8, "Minimun 8 numbers required").nullable(),
        financialAudit: Yup.string().required(ERROR_MSG).nullable(),
        auditCerti: Yup.string().when('financialAudit', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG),
            otherwise: Yup.string().nullable(),
        }),
        bankName2: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdrNo2: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdrNumberValidUpto2: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        ifscCode1: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION, 'Invalid Ifsc Code'),
            otherwise: Yup.string().nullable(),
        }),
        fdrNumberValidUpto1: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        ifscCode2: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION, 'Invalid Ifsc Code'),
            otherwise: Yup.string().nullable(),
        }),
        fdBondCerti2: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        fdBondCerti: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),



        bankName1: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        fdrNo: Yup.string().when('fdr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        branch: Yup.string().required(ERROR_MSG).nullable(),
        pgcrsavailable: Yup.string().required(ERROR_MSG).nullable(),
        clgrunning: Yup.string().required(ERROR_MSG).nullable(),

    })


    const showValidationError = (message) => {
        Swal.fire({
            text: message,
            icon: 'error',
            confirmButtonText: 'OK'
        });
    };
    const AffflIncomeFormik = useFormik({
        initialValues: {
            stateGovIncome: "",
            centralGovIncome: "",
            universityGrantsCommission: "",
            othersCentralStateGovBodies: "",
            privateTrust: "",
            donations: "",
            studentFee: "",
            internalRevenueGenerated: "",
            salaryOfFullTimeFaculty: "",
            salaryOfVisitingFaculty: "",
            salaryForNonTeachingStaff: "",
            library: "",
            computerCentre: "",
            equipmentForLabsWorkshop: "",
            nameOfThe: "",
            incomeDetailsOther: "",

            nameOfOtherExpenditure: "",
            expenditureSalOther: "",
            othersIncome: "",
            othersExpenditure: "",
            cashBalance: "",
            ifscCode: "",
            fdr: "",
            fdrNo: "",
            //  totalAmount:"",
            acNo: "",
            //
            //  finacial:"",
            //  remarksForFinacial:"",
            //  bondCerti: "",
            financialAudit: "",
            auditCerti: "",
            fdBondCerti: "",
            bankName: "",
            branch: "",
            pgcrsavailable: "",
            clgrunning: "",
            fdrNumberValidUpto1: "",
            bankName1: "",
            ifscCode1: "",
            bankName2: "",
            fdrNo2: "",
            fdrNumberValidUpto2: "",
            ifscCode2: "",
            fdBondCerti2: "",
            fdrNumber3: "",
            fdrNumberValidUpto3: "",
            bankName3: "",
            ifscCode3: "",
            fdrNumber4: "",
            fdBondCerti3: "",
            fdrNumberValidUpto4: "",
            bankName4: "",
            ifscCode4: "",
            fdBondCerti4: "",
            students: [
                {
                    feeTitle: "",
                    slno: "",
                    frequency: "",
                    amount: "",
                    cnrAmount: "",
                    mngAmount: "",
                }
            ]
        },

        validationSchema: AffliationIncomeDetailsValidation,
        onSubmit: (values) => {
            for (let i = 0; i < values?.students?.length; i++) {
                const student = values?.students[i];

                const course = feename[i];

                // Safely convert values to strings before using trim()
                const cnrAmount = student?.cnrAmount;
                const mngAmount = student?.mngAmount;
                const amount = student?.amount;

                // if (i === 0) {
                //     if (!cnrAmount) {
                //         showValidationError(`Convenor Quota Amount is required`);
                //         return; // Stop submission
                //     }
                //     if (!mngAmount) {
                //         showValidationError(`Management Quota Amount is required`);
                //         return; // Stop submission
                //     }
                // } else {
                //     if (!amount) {
                //         showValidationError(`Amount for ${course?.fee_title} is required`);
                //         return; // Stop submission
                //     }
                // }



                if (i === 0) {
                    if (cnrAmount == null || cnrAmount === '') {
                        showValidationError('Convenor Quota Amount is required');
                        return; // Stop submission
                    }
                    if (mngAmount == null || mngAmount === '') {
                        showValidationError('Management Quota Amount is required');
                        return; // Stop submission
                    }
                } else {
                    if (amount == null || amount === '') {
                        showValidationError(`Amount for ${course?.fee_title} is required`);
                        return; // Stop submission
                    }
                }


            }
            const payload = {
                nameOfOtherExpenditure: values?.nameOfOtherExpenditure || '',
                othersIncome: values?.othersIncome || '',
                nameOfThe: values?.nameOfThe || '',
                othersExpenditure: values?.othersExpenditure || '',
                ifscCode: values?.ifscCode || '',
                fdr: values?.fdr || '',
                fdrNo: values?.fdrNo || '',
                acNo: values?.acNo || '',
                // finacial: values?.finacial || '',
                // remarksForFinacial: values?.remarksForFinacial || '',
                // bondCerti: values?.bondCerti || '',
                financialAudit: values?.financialAudit || '',
                auditCerti: values?.auditCerti || '',
                fdBondCerti: values?.fdBondCerti || '',
                bankName: values?.bankName || '',
                branch: values?.branch || '',
                pgcrsavailable: values?.pgcrsavailable || '',
                clgrunning: values?.clgrunning || '',

                fdrNumberValidUpto1: values?.fdrNumberValidUpto1 || '',

                bankName1: values?.bankName1 || '',
                ifscCode1: values?.ifscCode1 || '',

                bankName2: values?.bankName2 || '',
                fdrNo2: values?.fdrNo2 || '',
                fdrNumberValidUpto2: values?.fdrNumberValidUpto2 || '',
                ifscCode2: values?.ifscCode2 || '',
                fdBondCerti2: values?.fdBondCerti2 || '',

                fdrNumber3: values?.fdrNumber3 || '',
                fdrNumberValidUpto3: values?.fdrNumberValidUpto3 || '',

                bankName3: values?.bankName3 || '',
                ifscCode3: values?.ifscCode3 || '',

                fdrNumber4: values?.fdrNumber4 || '',
                fdBondCerti3: values?.fdBondCerti3 || '',
                fdrNumberValidUpto4: values?.fdrNumberValidUpto4 || '',
                bankName4: values?.bankName4 || '',
                ifscCode4: values?.ifscCode4 || '',
                fdBondCerti4: values?.fdBondCerti4 || '',

                stateGovIncome: parseInt(values.stateGovIncome, 10) || 0,
                centralGovIncome: parseInt(values.centralGovIncome, 10) || 0,
                universityGrantsCommission: parseInt(values.universityGrantsCommission, 10) || 0,
                othersCentralStateGovBodies: parseInt(values.othersCentralStateGovBodies, 10) || 0,
                privateTrust: parseInt(values.privateTrust, 10) || 0,
                donations: parseInt(values.donations, 10) || 0,
                studentFee: parseInt(values.studentFee, 10) || 0,
                internalRevenueGenerated: parseInt(values.internalRevenueGenerated, 10) || 0,
                salaryOfFullTimeFaculty: parseInt(values.salaryOfFullTimeFaculty, 10) || 0,
                salaryOfVisitingFaculty: parseInt(values.salaryOfVisitingFaculty, 10) || 0,
                salaryForNonTeachingStaff: parseInt(values.salaryForNonTeachingStaff, 10) || 0,
                library: parseInt(values.library, 10) || 0,
                computerCentre: parseInt(values.computerCentre, 10) || 0,
                equipmentForLabsWorkshop: parseInt(values.equipmentForLabsWorkshop, 10) || 0,
                expenditureSalOther: parseInt(values.expenditureSalOther, 10) || 0,
                incomeDetailsOther: parseInt(values.incomeDetailsOther, 10) || 0,
                cashBalance: parseInt(values.cashBalance, 10) || 0,
                // totalAmount: parseInt(values.totalAmount, 10) || '',+
                students: values.students?.map((student, index) => ({
                    slno: index + 1,
                    amount: parseInt(student.amount, 10) || 0,
                    cnrAmount: parseInt(student.cnrAmount, 10) || 0,
                    mngAmount: parseInt(student.mngAmount, 10) || 0,
                    feeTitle: (student.feeTitle) || 0,
                })) || []
            };
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveIncomeDetails`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);

                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })

    const [feename, setfeename] = useState([]);
    function Feenames() {
        let url = config.url.API_URL + `feeTitleData`;
        CommonAxiosGet(url).then((res) => {

            if (res?.data?.scode === '01') {
                setfeename(res?.data?.feeTitleData);
                res?.data?.feeTitleData?.forEach((data, i) => {
                    AffflIncomeFormik?.setFieldValue(`students[${i}].feeTitle`, data?.fee_title)

                })
            }
            else {
                setfeename([]);
            }
        })
    }


    function StudentFeeDetails() {
        let url = config.url.API_URL + `getfeeStudentDetails`;
        CommonAxiosGet(url).then((res) => {

            if (res?.data?.scode === '01') {
                res?.data?.getfeeStudentDetails?.forEach((data, i) => {
                    AffflIncomeFormik?.setFieldValue(`students[${i}].amount`, data?.amount)
                    AffflIncomeFormik?.setFieldValue(`students[${i}].cnrAmount`, data?.cnr_amount)
                    AffflIncomeFormik?.setFieldValue(`students[${i}].mngAmount`, data?.mng_amount)
                })
            }
            else {
                console.log("api Data not found")
            }
        })
    }
    function IncomeExpenditureDetails() {
        let url = config.url.API_URL + `getIncomeAndExpenditureDetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const Fdrvalidupto1 = res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_1 && moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_1,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_1, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const Fdrvalidupto2 = res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_2 && moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_2,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_2, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const Fdrvalidupto3 = res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_3 && moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_3,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_3, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const Fdrvalidupto4 = res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_4 && moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_4,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getincomeDetails[0]?.fdr_number_valid_upto_4, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const incomeDetailsOtherValue = res?.data?.getincomeDetails[0]?.income_details_other;
                const incomeDetailsOther = incomeDetailsOtherValue === null || incomeDetailsOtherValue === undefined
                    ? '' : incomeDetailsOtherValue;

                AffflIncomeFormik?.setFieldValue('incomeDetailsOther', incomeDetailsOther);
                AffflIncomeFormik?.setFieldValue(`computerCentre`, res?.data?.getincomeDetails[0]?.computer_centre);
                AffflIncomeFormik?.setFieldValue(`centralGovIncome`, res?.data?.getincomeDetails[0]?.central_gov_income);
                AffflIncomeFormik?.setFieldValue(`bankName`, res?.data?.getincomeDetails[0]?.bank_name);
                AffflIncomeFormik?.setFieldValue(`bankName1`, res?.data?.getincomeDetails[0]?.bank_name_1);
                AffflIncomeFormik?.setFieldValue(`fdrNumberValidUpto1`, Fdrvalidupto1 ?? '');
                AffflIncomeFormik?.setFieldValue(`nameOfOtherExpenditure`, res?.data?.getincomeDetails[0]?.name_of_other_expenditure);
                AffflIncomeFormik?.setFieldValue(`nameOfThe`, res?.data?.getincomeDetails[0]?.name_of_the);
                AffflIncomeFormik?.setFieldValue(`auditCerti`, res?.data?.getincomeDetails[0]?.audit_certi);
                AffflIncomeFormik?.setFieldValue(`acNo`, res?.data?.getincomeDetails[0]?.ac_no);
                AffflIncomeFormik?.setFieldValue(`ifscCode1`, res?.data?.getincomeDetails[0]?.ifsc_code_1);
                AffflIncomeFormik?.setFieldValue(`universityGrantsCommission`, res?.data?.getincomeDetails[0]?.university_grants_commmission);
                AffflIncomeFormik?.setFieldValue(`ifscCode3`, res?.data?.getincomeDetails[0]?.ifsc_code_3);
                AffflIncomeFormik?.setFieldValue(`fdrNumberValidUpto3`, Fdrvalidupto3 ?? '', false);
                AffflIncomeFormik?.setFieldValue(`library`, res?.data?.getincomeDetails[0]?.library);
                AffflIncomeFormik?.setFieldValue(`internalRevenueGenerated`, res?.data?.getincomeDetails[0]?.internal_revenue_generated);
                AffflIncomeFormik?.setFieldValue(`fdrNo`, res?.data?.getincomeDetails[0]?.fdr_no);
                AffflIncomeFormik?.setFieldValue(`financialAudit`, res?.data?.getincomeDetails[0]?.financial_audit?.toString());
                AffflIncomeFormik?.setFieldValue(`fdrNumberValidUpto4`, Fdrvalidupto4 ?? '', false);
                AffflIncomeFormik?.setFieldValue(`cashBalance`, res?.data?.getincomeDetails[0]?.cash_balance);
                AffflIncomeFormik?.setFieldValue(`fdr`, res?.data?.getincomeDetails[0]?.fdr?.toString());
                AffflIncomeFormik?.setFieldValue(`bankName4`, res?.data?.getincomeDetails[0]?.bank_name_4);

                AffflIncomeFormik?.setFieldValue(`clgrunning`, res?.data?.getincomeDetails[0]?.clgrunning?.toString());
                AffflIncomeFormik?.setFieldValue(`bankName2`, res?.data?.getincomeDetails[0]?.bank_name_2);
                AffflIncomeFormik?.setFieldValue(`equipmentForLabsWorkshop`, res?.data?.getincomeDetails[0]?.equipment_for_labs_workshop);
                AffflIncomeFormik?.setFieldValue(`fdrNumberValidUpto2`, Fdrvalidupto2 ?? '', false);
                AffflIncomeFormik?.setFieldValue(`privateTrust`, res?.data?.getincomeDetails[0]?.private_trust);
                AffflIncomeFormik?.setFieldValue(`bankName3`, res?.data?.getincomeDetails[0]?.bank_name_3);
                AffflIncomeFormik?.setFieldValue(`fdBondCerti4`, res?.data?.getincomeDetails[0]?.fd_bond_certi_4);
                AffflIncomeFormik?.setFieldValue(`fdBondCerti2`, res?.data?.getincomeDetails[0]?.fd_bond_certi_2);
                AffflIncomeFormik?.setFieldValue(`branch`, res?.data?.getincomeDetails[0]?.branch);
                AffflIncomeFormik?.setFieldValue(`fdrNumber3`, res?.data?.getincomeDetails[0]?.fdr_number_3);
                AffflIncomeFormik?.setFieldValue(`ifscCode2`, res?.data?.getincomeDetails[0]?.ifsc_code_2);
                AffflIncomeFormik?.setFieldValue(`othersIncome`, res?.data?.getincomeDetails[0]?.others_income?.toString());
                AffflIncomeFormik?.setFieldValue(`salaryForNonTeachingStaff`, res?.data?.getincomeDetails[0]?.salary_for_non_teaching_staff);
                AffflIncomeFormik?.setFieldValue(`ifscCode`, res?.data?.getincomeDetails[0]?.ifsc_code);
                AffflIncomeFormik?.setFieldValue(`stateGovIncome`, res?.data?.getincomeDetails[0]?.state_gov_income);
                AffflIncomeFormik?.setFieldValue(`ifscCode4`, res?.data?.getincomeDetails[0]?.ifsc_code_4);
                AffflIncomeFormik?.setFieldValue(`othersCentralStateGovBodies`, res?.data?.getincomeDetails[0]?.others_central_state_gov_bodies);
                AffflIncomeFormik?.setFieldValue(`pgcrsavailable`, res?.data?.getincomeDetails[0]?.pgcrsavailable?.toString());
                AffflIncomeFormik?.setFieldValue(`fdrNumber4`, res?.data?.getincomeDetails[0]?.fdr_number_4);
                AffflIncomeFormik?.setFieldValue(`salaryOfVisitingFaculty`, res?.data?.getincomeDetails[0]?.salary_of_visiting_faculty);
                AffflIncomeFormik?.setFieldValue(`fdBondCerti`, res?.data?.getincomeDetails[0]?.fd_bond_certi_1);
                AffflIncomeFormik?.setFieldValue(`fdrNo2`, res?.data?.getincomeDetails[0]?.fdr_no_2);
                AffflIncomeFormik?.setFieldValue(`donations`, res?.data?.getincomeDetails[0]?.donations);
                AffflIncomeFormik?.setFieldValue(`othersExpenditure`, res?.data?.getincomeDetails[0]?.others_expenditure?.toString() ?? '');
                AffflIncomeFormik?.setFieldValue(`salaryOfFullTimeFaculty`, res?.data?.getincomeDetails[0]?.salary_of_full_time_faculty);
                AffflIncomeFormik?.setFieldValue(`studentFee`, res?.data?.getincomeDetails[0]?.student_fee);
                AffflIncomeFormik?.setFieldValue(`expenditureSalOther`, res?.data?.getincomeDetails[0]?.expenditure_sal_other);
                AffflIncomeFormik?.setFieldValue(`fdBondCerti3`, res?.data?.getincomeDetails[0]?.fd_bond_certi_3);
                AffflIncomeFormik?.setFieldValue('incomeDetailsOther', incomeDetailsOther);

            }
            else {
                console.log("No Data Found")
            }
        })
    }


    useEffect(() => {
        Feenames();
        StudentFeeDetails();
        IncomeExpenditureDetails();

    }, [])


    function ClearothersIncome() {
        AffflIncomeFormik.setFieldValue("nameOfThe", "");
        AffflIncomeFormik.setFieldValue("incomeDetailsOther", "");
    }
    function ClearothersExpenditure() {
        AffflIncomeFormik?.setFieldValue("nameOfOtherExpenditure", "");
        AffflIncomeFormik?.setFieldValue("expenditureSalOther", "");
    }
    function ClrFinancial() {
        AffflIncomeFormik?.setFieldValue("auditCerti", "");
    }
    function ClrFdr() {
        AffflIncomeFormik?.setFieldValue("fdrNumberValidUpto1", "");
        AffflIncomeFormik?.setFieldValue("fdBondCerti", "");
        AffflIncomeFormik?.setFieldValue("bankName1", "");
        AffflIncomeFormik?.setFieldValue("ifscCode1", "");
        AffflIncomeFormik?.setFieldValue("fdrNo", "");

        AffflIncomeFormik?.setFieldValue("bankName2", "");
        AffflIncomeFormik?.setFieldValue("fdrNo2", "");
        AffflIncomeFormik?.setFieldValue("ifscCode2", "");
        AffflIncomeFormik?.setFieldValue("fdBondCerti2", "");
        AffflIncomeFormik?.setFieldValue("fdrNumberValidUpto2", "");

        AffflIncomeFormik?.setFieldValue("bankName3", "");
        AffflIncomeFormik?.setFieldValue("fdrNumber3", "");
        AffflIncomeFormik?.setFieldValue("fdBondCerti3", "");
        AffflIncomeFormik?.setFieldValue("ifscCode3", "");
        AffflIncomeFormik?.setFieldValue("fdrNumberValidUpto3", "");

        AffflIncomeFormik?.setFieldValue("bankName4", "");
        AffflIncomeFormik?.setFieldValue("ifscCode4", "");
        AffflIncomeFormik?.setFieldValue("fdBondCerti4", "");
        AffflIncomeFormik?.setFieldValue("fdrNumber4", "");
        AffflIncomeFormik?.setFieldValue("fdrNumberValidUpto4", "");
    }
    return (
        <>
            <CommonFormHeading heading="Financial Details" />
            <bie.Container fluid className="px-1" >

                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AffflIncomeFormik}>
                        <bie.Row className="px-2 pt-3 mb-3">

                            <Form onChange={AffflIncomeFormik?.handleChange} onSubmit={AffflIncomeFormik?.handleSubmit} className='affl-form'>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0"> Grant/Revenue Received</h1></div>
                                <bie.Row className="px-2 my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Central Government Grant</b></label>
                                        <Field type='text' name="centralGovIncome" maxLength="10" className='form-control mb-2  down-marg4'
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="centralGovIncome" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>State Government Grant:</b></label>
                                        <Field type='text' name="stateGovIncome" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="stateGovIncome" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>University Grants Commission</b></label>
                                        <Field type='text' name="universityGrantsCommission" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="universityGrantsCommission" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Other state/Central government bodies</b></label>
                                        <Field type='text' name="othersCentralStateGovBodies" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="othersCentralStateGovBodies" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Private Trust</b></label>
                                        <Field type='text' name="privateTrust" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="privateTrust" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Donations</b></label>
                                        <Field type='text' name="donations" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="donations" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Student Fee</b></label>
                                        <Field type='text' name="studentFee" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="studentFee" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Internal Revenue Gnerated</b></label>
                                        <Field type='text' name="internalRevenueGenerated" maxLength="10" className='form-control mb-2 '
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="internalRevenueGenerated" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2 d-fle flex-column'>
                                        <label className='mb-1' ><b className='field-mandatory'>Others(Please specify)</b></label>
                                        <div className=''>
                                            <Field type="radio" name="othersIncome" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="othersIncome" value="false" onChange={(e) => { ClearothersIncome() }}
                                                onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />&nbsp; No

                                            <ErrorMessage name="othersIncome" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>
                                    {AffflIncomeFormik?.values?.othersIncome === "true" ? (<>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Source </b></label>
                                            <Field type='text' name="nameOfThe" className='form-control mb-2 ' maxLength="30" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                            <ErrorMessage name="nameOfThe" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Income</b></label>
                                            <Field type='text' name="incomeDetailsOther" maxLength="10" className='form-control mb-2 '
                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="incomeDetailsOther" component="div" className="text-error" />
                                        </bie.Col>
                                    </>) : (<></>)}
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className=""> Details of Fee Collected From Students</h1></div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm affl-table" >
                                        <thead>
                                            <tr>
                                                <th style={{ width: '5%' }}>S.No</th>
                                                <th style={{ width: '20%' }}>Title Of The Fee</th>
                                                <th style={{ width: '75%' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {feename?.map((course, index) => (
                                                <tr key={index}>
                                                    <td>{course?.slno}</td>
                                                    <td className='text-left'>{course?.fee_title}
                                                        <Field type="hidden" name={`students[${index}].feeTitle`} value={course?.ac_year} />
                                                    </td>
                                                    <td style={{ wordWrap: 'break-word' }}>
                                                        {index === 0 ? (
                                                            <>
                                                                <bie.Row>
                                                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={4} xxl={3} className="mb-2">
                                                                        <label className='mb-1'><b className="field-mandatory">Convenor Quota Amount</b></label>
                                                                        <Field
                                                                            type="text" maxLength="10"
                                                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                                            className="form-control" style={{ width: "14rem" }}
                                                                            name={`students[${index}].cnrAmount`}
                                                                        />

                                                                    </bie.Col>
                                                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={4} xxl={3} className="mb-2">
                                                                        <label className='mb-1'><b className="field-mandatory">Management Quota Amount</b></label>
                                                                        <Field
                                                                            type="text" maxLength="10"
                                                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                                            className="form-control" style={{ width: "14rem" }}
                                                                            name={`students[${index}].mngAmount`}
                                                                        />

                                                                    </bie.Col>
                                                                </bie.Row>
                                                            </>
                                                        ) : (
                                                            <Field
                                                                type="text" style={{ width: "50rem" }}
                                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                                className="form-control" maxLength="10"
                                                                name={`students[${index}].amount`}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className=""> Expenditure Details</h1></div>
                                <bie.Row className="px-2 pt-3 m-0">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Salary of full time faculty</b></label>
                                        <Field type='text' name="salaryOfFullTimeFaculty" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="salaryOfFullTimeFaculty" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Salary of visiting faculty</b></label>
                                        <Field type='text' name="salaryOfVisitingFaculty" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="salaryOfVisitingFaculty" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Salary of non-teaching staff</b></label>
                                        <Field type='text' name="salaryForNonTeachingStaff" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="salaryForNonTeachingStaff" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Library</b></label>
                                        <Field type='text' name="library" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="library" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Computer Center</b></label>
                                        <Field type='text' name="computerCentre" className='form-control mb-2  down-marg4' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="computerCentre" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1' ><b className='field-mandatory'>Equipment for Labs and Workshop</b></label>
                                        <Field type='text' name="equipmentForLabsWorkshop" className='form-control mb-2 ' maxLength="10"
                                            onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="equipmentForLabsWorkshop" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2 d-flex flex-column'>
                                        <label className='mb-1' ><b className='field-mandatory me-2'>Others(Please specify)</b></label>

                                        <div className='down-marg4'>
                                            <Field type="radio" name="othersExpenditure" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="othersExpenditure" value="false" onChange={(e) => { ClearothersExpenditure() }} />&nbsp; No

                                            <ErrorMessage name="othersExpenditure" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>

                                    {AffflIncomeFormik?.values?.othersExpenditure === "true" ? (<>

                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Expenditure for </b></label>
                                            <Field type='text' name="nameOfOtherExpenditure" className='form-control mb-2  down-marg4' maxLength="40"
                                                onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                            <ErrorMessage name="nameOfOtherExpenditure" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Expenditure </b></label>
                                            <Field type='text' name="expenditureSalOther" className='form-control mb-2  down-marg4' maxLength="10"
                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="expenditureSalOther" component="div" className="text-error" />
                                        </bie.Col>
                                    </>) : (<></>)}
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub">

                                    <h1 className="mb-0"> Financial Details of the Institution</h1></div>
                                <bie.Row className="px-2 pt-3 m-0 ">
                                    <bie.Row>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Bank Name</b></label>
                                            <Field type='text' name="bankName" className='form-control mb-2 ' maxLength="60" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />

                                            <ErrorMessage name="bankName" component="div" className="text-error" />

                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Branch</b></label>
                                            <Field type='text' name="branch" className='form-control mb-2 ' maxLength="80" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                            <ErrorMessage name="branch" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Account No</b></label>
                                            <Field type='text' name="acNo" className='form-control mb-2 ' maxLength="17"
                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />

                                            <ErrorMessage name="acNo" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Ifsc Code</b></label>
                                            <Field type='text' name="ifscCode" className='form-control mb-2 ' maxLength="11" onKeyUp={(e) => { handleAutoCapitalizeallowNumAlphat(e); }} />

                                            <ErrorMessage name="ifscCode" component="div" className="text-error" />

                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Cash Balance</b></label>
                                            <Field type='text' name="cashBalance" className='form-control mb-2 ' maxLength="10"
                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="cashBalance" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>Are PG courses available</b></label>
                                            <Field as='select' name="pgcrsavailable" className='form-control mb-2 '>
                                                <option value="">--Select--</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Field>

                                            <ErrorMessage name="pgcrsavailable" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory'>College running in Rural/Urban</b></label>
                                            <Field as='select' name="clgrunning" className='form-control mb-2 '>
                                                <option value="">--Select--</option>
                                                <option value="Rural">Rural</option>
                                                <option value="Urban">Urban</option>
                                            </Field>

                                            <ErrorMessage name="clgrunning" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory me-2'>Is Corpus Fund Applicable</b></label>
                                            <div className='form-control'>
                                                <Field type="radio" name="fdr" value="true" />&nbsp;Yes&emsp;
                                                <Field type="radio" name="fdr" value="false" onChange={(e) => { ClrFdr() }} />&nbsp; No
                                                <ErrorMessage name="fdr" component="div" className="text-error" />
                                            </div>
                                        </bie.Col>
                                    </bie.Row>
                                    {AffflIncomeFormik?.values?.fdr === "true" ? (<>

                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>FDR Number	</th>
                                                        <th>FDR Valid Up to	</th>
                                                        <th>Bank Name	</th>
                                                        <th>Ifsc Code	</th>
                                                        <th> Upload</th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>1</td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="fdrNo" maxLength="10" onKeyPress={(e) => { handleAutoCapitalizeallowNumAlphat(e); }} />
                                                            <ErrorMessage name="fdrNo" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="date" className="form-control" name="fdrNumberValidUpto1" onKeyDown={(e) => { e.preventDefault() }} />
                                                            <ErrorMessage name="fdrNumberValidUpto1" component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name="bankName1" maxLength="80"
                                                                onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                            <ErrorMessage name="bankName1" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="ifscCode1" maxLength="11"
                                                                onKeyUp={(e) => { handleAutoCapitalizeallowNumAlphat(e) }} />
                                                            <ErrorMessage name="ifscCode1" component="div" className="text-error" />
                                                        </td> <td>

                                                            <div className='d-flex align-items-center'>
                                                                <input type="file" className="form-control" name="fdBondCerti" accept="application/pdf"
                                                                    onChange={(e) => {
                                                                        let fileVal = userId + "_" + acYear;
                                                                        let filename = fileVal + "fdBondCerti"
                                                                        let path = "/Uploads/AffiliationFDBondPDFs/2023_24/"
                                                                        ImagePdfBucket(e, AffflIncomeFormik, path, `fdBondCerti`, filename, "pdf")
                                                                    }}
                                                                />
                                                                {AffflIncomeFormik?.values?.fdBondCerti && AffflIncomeFormik?.values?.fdBondCerti.trim() !== 'nullnull' && <button type='button' className="btn btn-primary" onClick={() => { viewImage(AffflIncomeFormik?.values?.fdBondCerti) }}><FaEye size={23} className='ms-2' /></button>}

                                                                <ErrorMessage name="fdBondCerti" component="div" className="text-error" />
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>2</td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="fdrNo2" maxLength="10" onKeyPress={(e) => { handleAutoCapitalizeallowNumAlphat(e); }} />
                                                            <ErrorMessage name="fdrNo2" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="date" className="form-control" name="fdrNumberValidUpto2" onKeyDown={(e) => { e.preventDefault() }} />
                                                            <ErrorMessage name="fdrNumberValidUpto2" component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name="bankName2" maxLength="80" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                            <ErrorMessage name="bankName2" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="ifscCode2" onKeyUp={(e) => { handleAutoCapitalizeallowNumAlphat(e) }} maxLength="11" />
                                                            <ErrorMessage name="ifscCode2" component="div" className="text-error" />
                                                        </td> <td>

                                                            <div className='d-flex align-items-center'>
                                                                <input type="file" className="form-control" name="fdBondCerti2" accept="application/pdf"
                                                                    onChange={(e) => {
                                                                        let fileVal = userId + "_" + acYear;
                                                                        let filename = fileVal + "fdBondCerti2"
                                                                        let path = "/Uploads/AffiliationFDBondPDFs/2023_24/"
                                                                        ImagePdfBucket(e, AffflIncomeFormik, path, `fdBondCerti2`, filename, "pdf")
                                                                    }}
                                                                />
                                                                {AffflIncomeFormik?.values?.fdBondCerti2 && AffflIncomeFormik?.values?.fdBondCerti2.trim() !== 'nullnull' && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(AffflIncomeFormik?.values?.fdBondCerti2) }}><FaEye size={23} /></button>}
                                                                <ErrorMessage name="fdBondCerti2" component="div" className="text-error" />
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>3</td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="fdrNumber3" maxLength="10" onKeyPress={(e) => { handleAutoCapitalizeallowNumAlphat(e); }} />
                                                            <ErrorMessage name="fdrNumber3" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="date" className="form-control" name="fdrNumberValidUpto3" onKeyDown={(e) => { e.preventDefault() }} />
                                                            <ErrorMessage name="fdrNumberValidUpto3" component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name="bankName3" maxLength="80" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                            <ErrorMessage name="bankName3" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="ifscCode3" maxLength="11" onKeyUp={(e) => { handleAutoCapitalizeallowNumAlphat(e) }} />
                                                            <ErrorMessage name="ifscCode3" component="div" className="text-error" />
                                                        </td> <td>

                                                            <div className='d-flex align-items-center'>
                                                                <input type="file" className="form-control" name="fdBondCerti3" accept="application/pdf"
                                                                    onChange={(e) => {
                                                                        let fileVal = userId + "_" + acYear;
                                                                        let filename = fileVal + "fdBondCerti3"
                                                                        let path = "/Uploads/AffiliationFDBondPDFs/2023_24/"
                                                                        ImagePdfBucket(e, AffflIncomeFormik, path, `fdBondCerti3`, filename, "pdf")
                                                                    }}
                                                                />
                                                                {AffflIncomeFormik?.values?.fdBondCerti3 && AffflIncomeFormik?.values?.fdBondCerti3.trim() !== 'nullnull' && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(AffflIncomeFormik?.values?.fdBondCerti3) }}><FaEye size={23} /></button>}
                                                                <ErrorMessage name="fdBondCerti3" component="div" className="text-error" />
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>4</td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="fdrNumber4" maxLength="10" onKeyPress={(e) => { handleAutoCapitalizeallowNumAlphat(e); }} />
                                                            <ErrorMessage name="fdrNumber4" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="date" className="form-control" name="fdrNumberValidUpto4" onKeyDown={(e) => { e.preventDefault() }} />
                                                            <ErrorMessage name="fdrNumberValidUpto4" component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name="bankName4" maxLength="80" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                            <ErrorMessage name="bankName4" component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control" name="ifscCode4" maxLength="11" onKeyUp={(e) => { handleAutoCapitalizeallowNumAlphat(e) }} />
                                                            <ErrorMessage name="ifscCode4" component="div" className="text-error" />
                                                        </td> <td>

                                                            <div className='d-flex align-items-center'>
                                                                <input type="file" className="form-control" name="fdBondCerti4" accept="application/pdf"
                                                                    onChange={(e) => {
                                                                        let fileVal = userId + "_" + acYear;
                                                                        let filename = fileVal + "fdBondCerti4"
                                                                        let path = "/Uploads/AffiliationFDBondPDFs/2023_24/"
                                                                        ImagePdfBucket(e, AffflIncomeFormik, path, `fdBondCerti4`, filename, "pdf")
                                                                    }}
                                                                />
                                                                {AffflIncomeFormik?.values?.fdBondCerti4 && AffflIncomeFormik?.values?.fdBondCerti4.trim() !== 'nullnull' && <button type='button' className='ms-3 btn btn-primary' onClick={() => { viewImage(AffflIncomeFormik?.values?.fdBondCerti4) }}><FaEye size={23} /></button>}
                                                                <ErrorMessage name="fdBondCerti4" component="div" className="text-error" />
                                                            </div>
                                                        </td>

                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>
                                    </>) : (<></>)}
                                    <bie.Row>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                            <label className='mb-1' ><b className='field-mandatory me-2'>Is Financial Audit completed for the Financial Year </b></label>
                                            <div className='form-control'>
                                                <Field type="radio" name="financialAudit" value="true" />&nbsp;Yes&emsp;
                                                <Field type="radio" name="financialAudit" value="false" onChange={(e) => { ClrFinancial() }} />&nbsp; No
                                                <ErrorMessage name="financialAudit" component="div" className="text-error" />
                                            </div>
                                        </bie.Col>
                                        {AffflIncomeFormik?.values?.financialAudit === "true" ? (<>
                                            <bie.Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={4} className='mb-2'>
                                                <label className='mb-1'><b className='field-mandatory'>Latest Financial Audit Report given by CA ( PDF)</b></label>
                                                <div className='d-flex align-items-center'>
                                                    <input type="file" className="form-control" name="auditCerti" accept="application/pdf"
                                                        onChange={(e) => {
                                                            let fileVal = userId + "_" + acYear;
                                                            let filename = fileVal + "auditCerti"
                                                            let path = "/Uploads/AffiliationAuditPDFs/2023_24/"
                                                            ImagePdfBucket(e, AffflIncomeFormik, path, `auditCerti`, filename, "pdf")
                                                        }}
                                                    />
                                                    {AffflIncomeFormik?.values?.auditCerti && AffflIncomeFormik?.values?.auditCerti.trim() !== 'nullnull' && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(AffflIncomeFormik?.values?.auditCerti) }}><FaEye size={23} /></button>}
                                                    <ErrorMessage name="auditCerti" component="div" className="text-error" />
                                                </div>
                                            </bie.Col>

                                        </>) : (<></>)}
                                    </bie.Row>

                                </bie.Row>

                                <div className="button-cend pt-1 mb-4">
                                    <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button>
                                </div>
                            </Form>
                        </bie.Row>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>
        </>
    )
}
